import { render, staticRenderFns } from "./sandOrderListPhone.vue?vue&type=template&id=7a0c2033&scoped=true&"
import script from "./sandOrderListPhone.vue?vue&type=script&lang=js&"
export * from "./sandOrderListPhone.vue?vue&type=script&lang=js&"
import style0 from "./sandOrderListPhone.vue?vue&type=style&index=0&id=7a0c2033&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0c2033",
  null
  
)

export default component.exports